module.exports = __webpack_public_path__ + "img/upcoming-storage.a26b9139.png";